(function () {
  const K = {
    businessName: "Express Signs DMV",
    emailTo: "orders@expresssignsdmv.com",
    phone: "(301) 885-3510",
    phoneHref: "tel:13018853510",
    address: "10 Irongate Dr STE H, Waldorf, MD 20602",
    apparelSite: "https://waldorfscreenprinting.com",

    greeting:
      "Hi! I’m the Express Signs DMV AI Front Desk. I can help you start an order, get an estimate, answer questions, or collect details for a custom sign project.",

    businessInfo: {
      hours:
        "Our showroom is open Monday through Friday from 10:00 AM to 4:00 PM. We are closed Saturday and Sunday.",
      pickup:
        "Yes — local pickup is available at Express Signs DMV: 10 Irongate Dr STE H, Waldorf, MD 20602. The team will confirm when your order is ready for pickup.",
      artwork:
        "After submitting your request, you’ll receive a secure link to upload your artwork, logos, or photos. Need help with your design? Our in-house graphic designer can help create or prepare your artwork before production begins.",
      turnaround:
        "Turnaround depends on product, quantity, artwork readiness, and the current production schedule. Business cards are typically 2–3 business days after artwork approval.",
      serviceAreas:
        "We serve Waldorf, Southern Maryland, Charles County, Prince George’s County, Washington DC, Northern Virginia, and the DMV area.",
      apparel:
        "Yes — screen printing, embroidery, apparel, uniforms, decals, stickers, vehicle graphics, and wraps are available. Apparel orders are handled through WaldorfScreenPrinting.com."
    },

    featherFlags: {
      small: { label: "Small 8 ft", prices: [{ min: 1, max: 4, price: 179 }, { min: 5, max: 9, price: 169 }, { min: 10, max: 999999, price: 159 }] },
      medium: { label: "Medium 10 ft", prices: [{ min: 1, max: 4, price: 199 }, { min: 5, max: 9, price: 189 }, { min: 10, max: 999999, price: 179 }] },
      large: { label: "Large 15 ft", prices: [{ min: 1, max: 4, price: 249 }, { min: 5, max: 9, price: 229 }, { min: 10, max: 999999, price: 209 }] },
      addons: { doubleSided: 50, crossBase: 30, waterBag: 15 }
    },

    fatheads: {
      "2ft": 79,
      "3ft": 129,
      "4ft": 179,
      "5ft": 229,
      "6ft": 279,
      addons: { outdoorLaminate: 25, rush: 35, sameDay: 75 }
    },

    businessCards: {
      turnaround: "2–3 business days after artwork approval",
      quantities: {
        "250": { matte: 49, gloss: 54 },
        "500": { matte: 69, gloss: 74 },
        "1000": { matte: 89, gloss: 99 }
      },
      addons: { designHelp: 50, roundedCorners: 15 }
    },

    aFrames: {
      insertSingle: 59,
      insertDouble: 89,
      standOnly: 109,
      complete: 189,
      extraInsert: 79
    }
  };

  function money(n) {
    return "$" + Number(n || 0).toFixed(2);
  }

  function tier(tiers, qty) {
    return tiers.find(t => qty >= t.min && qty <= t.max)?.price || 0;
  }

  function hasCalc() {
    return typeof window.ES_CALC !== "undefined";
  }

  function css() {
    const s = document.createElement("style");
    s.innerHTML = `
      .aifd-launcher{position:fixed;right:22px;bottom:22px;width:64px;height:64px;border-radius:50%;background:#14b8a6;color:#031426;display:flex;align-items:center;justify-content:center;font-size:30px;cursor:pointer;z-index:999999;box-shadow:0 12px 30px rgba(20,184,166,.35);font-weight:900}
      .aifd-box{position:fixed;right:22px;bottom:100px;width:390px;max-width:calc(100vw - 30px);background:#fff;border-radius:22px;overflow:hidden;z-index:999999;box-shadow:0 20px 50px rgba(0,0,0,.28);transform:translateY(20px);opacity:0;pointer-events:none;transition:.25s ease;border:1px solid rgba(20,184,166,.25)}
      .aifd-box.open{transform:translateY(0);opacity:1;pointer-events:auto}
      .aifd-head{background:#031426;color:#fff;padding:18px;display:flex;justify-content:space-between;align-items:center}
      .aifd-head strong{font-size:15px;line-height:1.2}
      .aifd-head button{background:none;border:none;color:#fff;font-size:24px;cursor:pointer}
      .aifd-body{padding:18px;max-height:70vh;overflow:auto}
      .aifd-msg{background:#062a4d;color:#fff;padding:16px;border-radius:16px;margin-bottom:14px;line-height:1.5;font-size:15px}
      .aifd-body button,.aifd-body select,.aifd-body input,.aifd-body textarea{width:100%;margin-top:10px;padding:13px;border-radius:12px;font-size:15px;box-sizing:border-box}
      .aifd-body button{border:none;background:#14b8a6;color:#031426;font-weight:900;cursor:pointer}
      .aifd-body button:hover{filter:brightness(.95)}
      .aifd-body input,.aifd-body select,.aifd-body textarea{border:1px solid #d7e3ef}
      .aifd-secondary{background:#eef5f7!important;color:#031426!important}
    `;
    document.head.appendChild(s);
  }

  function build() {
    const d = document.createElement("div");
    d.innerHTML = `
      <div class="aifd-launcher" onclick="AIFrontDesk.open()">💬</div>
      <div class="aifd-box">
        <div class="aifd-head">
          <strong>Express Signs DMV AI Front Desk</strong>
          <button onclick="AIFrontDesk.close()">×</button>
        </div>
        <div class="aifd-body" id="aifdBody"></div>
      </div>`;
    document.body.appendChild(d);
  }

  function body(html) {
    document.getElementById("aifdBody").innerHTML = html;
  }

  window.AIFrontDesk = {
    currentLead: null,
    currentCart: null,

    open: function () {
      document.querySelector(".aifd-box").classList.add("open");
      this.home();
    },

    close: function () {
      document.querySelector(".aifd-box").classList.remove("open");
    },

    home: function () {
      body(`
        <div class="aifd-msg">${K.greeting}</div>
        <button onclick="AIFrontDesk.orderMenu()">Start An Order</button>
        <button onclick="AIFrontDesk.helpMeChoose()">Help Me Choose</button>
        <button onclick="AIFrontDesk.customBusinessSigns()">Custom Business Signs</button>
        <button onclick="AIFrontDesk.metalSigns()">Metal Signs</button>
        <button onclick="AIFrontDesk.infoMenu()" class="aifd-secondary">Questions / Business Info</button>
      `);
    },

    orderMenu: function () {
      body(`
        <div class="aifd-msg">What would you like to order today?</div>
        <button onclick="AIFrontDesk.yardSigns()">Yard Signs — Checkout Online</button>
        <button onclick="AIFrontDesk.banners()">Banners — Checkout Online</button>
        <button onclick="AIFrontDesk.realEstateSigns()">Real Estate Signs</button>
        <button onclick="AIFrontDesk.contractorSigns()">Contractor Signs</button>
        <button onclick="AIFrontDesk.politicalSigns()">Political / Campaign Signs</button>
        <button onclick="AIFrontDesk.featherFlags()">Feather Flags — Estimate</button>
        <button onclick="AIFrontDesk.businessCards()">Business Cards — Estimate</button>
        <button onclick="AIFrontDesk.aFrames()">A-Frame Signs — Estimate</button>
        <button onclick="AIFrontDesk.fatheads()">Custom Fathead Cutouts — Estimate</button>
        <button onclick="AIFrontDesk.decalsWraps()">Decals / Stickers / Wraps</button>
        <button onclick="AIFrontDesk.quote()">Custom Sign Help</button>
        <button onclick="AIFrontDesk.home()" class="aifd-secondary">Back</button>
      `);
    },

    helpMeChoose: function () {
      body(`
        <div class="aifd-msg">What are you trying to accomplish?</div>
        <button onclick="AIFrontDesk.realEstateSigns()">I’m a Realtor / I need real estate signs</button>
        <button onclick="AIFrontDesk.contractorSigns()">I’m a contractor / I need job site signs</button>
        <button onclick="AIFrontDesk.politicalSigns()">I need campaign or political signs</button>
        <button onclick="AIFrontDesk.yardSigns()">Promote a yard, job site, campaign, or event</button>
        <button onclick="AIFrontDesk.banners()">I need a banner for a sale, event, school, or storefront</button>
        <button onclick="AIFrontDesk.featherFlags()">I need roadside attention / grand opening visibility</button>
        <button onclick="AIFrontDesk.aFrames()">I need a sidewalk or storefront sign</button>
        <button onclick="AIFrontDesk.businessCards()">I need business cards</button>
        <button onclick="AIFrontDesk.customBusinessSigns()">I need a custom business sign</button>
        <button onclick="AIFrontDesk.decalsWraps()">I need decals, stickers, or wraps</button>
        <button onclick="AIFrontDesk.quote()">I’m not sure / I need help</button>
      `);
    },

    infoMenu: function () {
      body(`
        <div class="aifd-msg">What would you like to know?</div>
        <button onclick="AIFrontDesk.answer('hours')">What are your hours?</button>
        <button onclick="AIFrontDesk.answer('pickup')">Can I pick up locally?</button>
        <button onclick="AIFrontDesk.answer('artwork')">How do I upload artwork?</button>
        <button onclick="AIFrontDesk.answer('turnaround')">How long does production take?</button>
        <button onclick="AIFrontDesk.answer('serviceAreas')">Do you serve DC / Northern Virginia?</button>
        <button onclick="AIFrontDesk.answer('apparel')">Do you do screen printing, embroidery, decals, or wraps?</button>
        <button onclick="AIFrontDesk.orderMenu()">Start An Order</button>
        <button onclick="AIFrontDesk.home()" class="aifd-secondary">Back</button>
      `);
    },

    answer: function (key) {
      body(`
        <div class="aifd-msg">${K.businessInfo[key]}</div>
        ${key === "apparel" ? `<button onclick="window.location.href='${K.apparelSite}'">Visit WaldorfScreenPrinting.com</button>` : ""}
        <button onclick="AIFrontDesk.infoMenu()">More Questions</button>
        <button onclick="AIFrontDesk.orderMenu()">Start An Order</button>
      `);
    },

    yardSigns: function () {
      body(`
        <div class="aifd-msg">Great — I can price yard signs and send you to checkout.</div>
        <select id="ysSize">
          <option value="12x18">12x18 Yard Signs</option>
          <option value="18x24">18x24 Yard Signs</option>
          <option value="24x36">24x36 Yard Signs</option>
          <option value="4x8">4x8 Large Signs</option>
        </select>
        <input id="ysQty" type="number" min="1" value="1" placeholder="Quantity">
        <select id="ysDouble">
          <option value="no">Single-sided</option>
          <option value="yes">Double-sided</option>
        </select>
        <select id="ysStakes">
          <option value="yes">Include H-stakes</option>
          <option value="no">No H-stakes</option>
        </select>
        <select id="ysRush">
          <option value="standard">Standard Production</option>
          <option value="next">Next Day +$25</option>
          <option value="same">Same Day +$50</option>
        </select>
        <button onclick="AIFrontDesk.calcYardSigns()">Get Price</button>
        <button onclick="AIFrontDesk.orderMenu()" class="aifd-secondary">Back</button>
      `);
    },

    calcYardSigns: function () {
      if (!hasCalc()) return alert("Pricing engine not loaded.");
      const size = document.getElementById("ysSize").value;
      const qty = Math.max(1, parseInt(document.getElementById("ysQty").value, 10) || 1);
      const options = {
        double: document.getElementById("ysDouble").value === "yes",
        stakes: document.getElementById("ysStakes").value === "yes",
        stakeQty: qty,
        nextDay: document.getElementById("ysRush").value === "next",
        sameDay: document.getElementById("ysRush").value === "same"
      };
      const result = window.ES_CALC.calculate("yard", size, qty, options);
      this.currentCart = { type: "yard", size, qty, options };
      body(`
        <div class="aifd-msg">Your estimated total is <strong>${money(result.total)}</strong>.<br><br>Would you like to add this to cart and checkout?</div>
        <button onclick="AIFrontDesk.addCurrentToCart()">Add To Cart & Checkout</button>
        <button onclick="AIFrontDesk.yardSigns()">Change Options</button>
      `);
    },

    banners: function () {
      body(`
        <div class="aifd-msg">Great — I can price banners and send you to checkout.</div>
        <select id="bnSize">
          <option value="2x3">2x3 Banner</option>
          <option value="3x5">3x5 Banner</option>
          <option value="4x8">4x8 Banner</option>
        </select>
        <input id="bnQty" type="number" min="1" value="1" placeholder="Quantity">
        <select id="bnRush">
          <option value="standard">Standard Production</option>
          <option value="next">Next Day +$25</option>
          <option value="same">Same Day +$50</option>
        </select>
        <button onclick="AIFrontDesk.calcBanners()">Get Price</button>
        <button onclick="AIFrontDesk.orderMenu()" class="aifd-secondary">Back</button>
      `);
    },

    calcBanners: function () {
      if (!hasCalc()) return alert("Pricing engine not loaded.");
      const size = document.getElementById("bnSize").value;
      const qty = Math.max(1, parseInt(document.getElementById("bnQty").value, 10) || 1);
      const options = {
        nextDay: document.getElementById("bnRush").value === "next",
        sameDay: document.getElementById("bnRush").value === "same"
      };
      const result = window.ES_CALC.calculate("banner", size, qty, options);
      this.currentCart = { type: "banner", size, qty, options };
      body(`
        <div class="aifd-msg">Your estimated total is <strong>${money(result.total)}</strong>.<br><br>Would you like to add this to cart and checkout?</div>
        <button onclick="AIFrontDesk.addCurrentToCart()">Add To Cart & Checkout</button>
        <button onclick="AIFrontDesk.banners()">Change Options</button>
      `);
    },

    addCurrentToCart: function () {
      if (!hasCalc()) return alert("Pricing engine not loaded.");
      const item = this.currentCart;
      if (!item) return alert("No item selected.");
      window.ES_CALC.addToCart(item.type, item.size, item.qty, item.options);
    },

    featherFlags: function () {
      body(`
        <div class="aifd-msg">Great — I can estimate feather flags and send the request to the team for confirmation.</div>
        <select id="ffSize">
          <option value="small">Small 8 ft</option>
          <option value="medium">Medium 10 ft</option>
          <option value="large">Large 15 ft</option>
        </select>
        <input id="ffQty" type="number" min="1" value="1" placeholder="Quantity">
        <select id="ffSide">
          <option value="single">Single-sided</option>
          <option value="double">Double-sided +$50 each</option>
        </select>
        <select id="ffBase">
          <option value="stake">Ground stake included</option>
          <option value="cross">Cross base +$30 each</option>
        </select>
        <select id="ffWater">
          <option value="no">No water bag</option>
          <option value="yes">Add water bag +$15 each</option>
        </select>
        <button onclick="AIFrontDesk.calcFeatherFlag()">Get Estimate</button>
        <button onclick="AIFrontDesk.orderMenu()" class="aifd-secondary">Back</button>
      `);
    },

    calcFeatherFlag: function () {
      const size = document.getElementById("ffSize").value;
      const qty = Math.max(1, parseInt(document.getElementById("ffQty").value, 10) || 1);
      const side = document.getElementById("ffSide").value;
      const base = document.getElementById("ffBase").value;
      const water = document.getElementById("ffWater").value;
      let total = tier(K.featherFlags[size].prices, qty) * qty;
      if (side === "double") total += K.featherFlags.addons.doubleSided * qty;
      if (base === "cross") total += K.featherFlags.addons.crossBase * qty;
      if (water === "yes") total += K.featherFlags.addons.waterBag * qty;
      this.leadForm("Feather Flags", money(total), `Size: ${K.featherFlags[size].label}, Qty: ${qty}, Side: ${side}, Base: ${base}, Water Bag: ${water}`);
    },

    businessCards: function () {
      body(`
        <div class="aifd-msg">Business cards are typically ready in 2–3 business days after artwork approval.</div>
        <select id="bcQty">
          <option value="250">250 Cards</option>
          <option value="500">500 Cards</option>
          <option value="1000">1,000 Cards</option>
        </select>
        <select id="bcFinish">
          <option value="matte">14pt Matte</option>
          <option value="gloss">16pt Gloss</option>
        </select>
        <select id="bcDesign">
          <option value="ready">I have print-ready artwork</option>
          <option value="help">I need design help +$50</option>
        </select>
        <select id="bcCorners">
          <option value="no">Standard corners</option>
          <option value="yes">Rounded corners +$15</option>
        </select>
        <button onclick="AIFrontDesk.calcBusinessCards()">Get Estimate</button>
        <button onclick="AIFrontDesk.orderMenu()" class="aifd-secondary">Back</button>
      `);
    },

    calcBusinessCards: function () {
      const qty = document.getElementById("bcQty").value;
      const finish = document.getElementById("bcFinish").value;
      const design = document.getElementById("bcDesign").value;
      const corners = document.getElementById("bcCorners").value;
      let total = K.businessCards.quantities[qty][finish];
      if (design === "help") total += K.businessCards.addons.designHelp;
      if (corners === "yes") total += K.businessCards.addons.roundedCorners;
      this.leadForm("Business Cards", money(total), `Qty: ${qty}, Finish: ${finish}, Design: ${design}, Corners: ${corners}, Turnaround: ${K.businessCards.turnaround}`);
    },

    aFrames: function () {
      body(`
        <div class="aifd-msg">I can estimate A-frame signs and send the request to the team.</div>
        <select id="afType">
          <option value="insertSingle">24x36 Printed Insert Only - Single-sided</option>
          <option value="insertDouble">24x36 Printed Inserts - Double-sided</option>
          <option value="standOnly">A-Frame Stand Only</option>
          <option value="complete">Complete A-Frame: Stand + 2 Printed Inserts</option>
          <option value="extraInsert">Additional Printed Inserts</option>
        </select>
        <input id="afQty" type="number" min="1" value="1" placeholder="Quantity">
        <select id="afArtwork">
          <option value="ready">I have artwork ready</option>
          <option value="help">I need design help</option>
        </select>
        <input id="afTimeline" placeholder="When do you need it?">
        <button onclick="AIFrontDesk.calcAFrame()">Get Estimate</button>
        <button onclick="AIFrontDesk.orderMenu()" class="aifd-secondary">Back</button>
      `);
    },

    calcAFrame: function () {
      const type = document.getElementById("afType").value;
      const qty = Math.max(1, parseInt(document.getElementById("afQty").value, 10) || 1);
      const artwork = document.getElementById("afArtwork").value;
      const timeline = document.getElementById("afTimeline").value;
      const total = K.aFrames[type] * qty;
      this.leadForm("A-Frame Signs", money(total), `Type: ${type}, Qty: ${qty}, Artwork: ${artwork}, Timeline: ${timeline}`);
    },

    fatheads: function () {
      body(`
        <div class="aifd-msg">Great — I can estimate custom fathead cutouts.</div>
        <select id="fhSize">
          <option value="2ft">Up to 2 ft - $79</option>
          <option value="3ft">Up to 3 ft - $129</option>
          <option value="4ft">Up to 4 ft - $179</option>
          <option value="5ft">Up to 5 ft - $229</option>
          <option value="6ft">Up to 6 ft - $279</option>
        </select>
        <input id="fhQty" type="number" min="1" value="1" placeholder="Quantity">
        <select id="fhOutdoor">
          <option value="no">Indoor</option>
          <option value="yes">Outdoor laminate +$25 each</option>
        </select>
        <select id="fhRush">
          <option value="standard">Standard production</option>
          <option value="rush">Rush +$35</option>
          <option value="same">Same day +$75</option>
        </select>
        <button onclick="AIFrontDesk.calcFathead()">Get Estimate</button>
        <button onclick="AIFrontDesk.orderMenu()" class="aifd-secondary">Back</button>
      `);
    },

    calcFathead: function () {
      const size = document.getElementById("fhSize").value;
      const qty = Math.max(1, parseInt(document.getElementById("fhQty").value, 10) || 1);
      const outdoor = document.getElementById("fhOutdoor").value;
      const rush = document.getElementById("fhRush").value;
      let total = K.fatheads[size] * qty;
      if (qty >= 10) total *= 0.80;
      else if (qty >= 5) total *= 0.85;
      else if (qty >= 2) total *= 0.90;
      if (outdoor === "yes") total += K.fatheads.addons.outdoorLaminate * qty;
      if (rush === "rush") total += K.fatheads.addons.rush;
      if (rush === "same") total += K.fatheads.addons.sameDay;
      this.leadForm("Custom Fathead Cutouts", money(total), `Size: ${size}, Qty: ${qty}, Outdoor: ${outdoor}, Rush: ${rush}`);
    },

    realEstateSigns: function () {
      this.customLeadForm("Real Estate Signs", [
        ["signType", "What type of real estate sign do you need? Yard signs, metal property signs, open house signs, directional signs, riders, post signs, or not sure?"],
        ["quantity", "How many signs do you need?"],
        ["size", "Do you know the size? 18x24, 24x36, custom size, or not sure?"],
        ["sides", "Single-sided or double-sided?"],
        ["riders", "Do you need riders? For Sale, Sold, Open House, Coming Soon, Under Contract, or custom rider text."],
        ["stakesOrPosts", "Do you need H-stakes, metal frames, or posts?"],
        ["agentInfo", "Agent name, brokerage, phone number, website, or QR code to include on the sign."],
        ["artwork", "Do you already have artwork or brokerage branding files?"],
        ["timeline", "When do you need the signs ready?"],
        ["pickup", "Will you pick up locally in Waldorf or need to ask about delivery?"],
        ["notes", "Anything else we should know?"]
      ]);
    },

    contractorSigns: function () {
      this.customLeadForm("Contractor Signs", [
        ["signType", "What type of contractor sign do you need? Yard signs, job site signs, banners, truck decals, safety signs, parking signs, or not sure?"],
        ["trade", "What type of contractor/business are you? Roofing, remodeling, landscaping, plumbing, electrical, HVAC, concrete, or other?"],
        ["quantity", "How many signs do you need?"],
        ["size", "Do you know the size? 18x24, 24x36, 4x8, banner size, custom size, or not sure?"],
        ["placement", "Where will these be used? Job sites, trucks, storefront, fence, roadside, event, or other?"],
        ["sides", "Single-sided or double-sided?"],
        ["stakesOrMounting", "Do you need stakes, posts, holes, grommets, mounting, or installation?"],
        ["artwork", "Do you already have a logo or artwork?"],
        ["timeline", "When do you need them ready?"],
        ["notes", "Anything else we should know?"]
      ]);
    },

    politicalSigns: function () {
      this.customLeadForm("Political / Campaign Signs", [
        ["signType", "What type of campaign sign do you need? Yard signs, large signs, banners, rally signs, directional signs, or not sure?"],
        ["quantity", "How many signs do you need?"],
        ["size", "What size? 18x24, 24x36, 4x8, banner size, custom size, or not sure?"],
        ["sides", "Single-sided or double-sided?"],
        ["stakes", "Do you need H-stakes included?"],
        ["candidateInfo", "Candidate name, office, slogan, website, QR code, or required wording."],
        ["artwork", "Do you already have print-ready artwork?"],
        ["deadline", "What is your deadline or event date?"],
        ["pickup", "Will you pick up locally in Waldorf or need to ask about delivery?"],
        ["notes", "Anything else we should know?"]
      ]);
    },

    customBusinessSigns: function () {
      this.customLeadForm("Custom Business Signs", [
        ["signType", "What type of sign? Storefront, channel letters, monument, post & panel, lobby, window graphics, wall graphics, directional, or not sure?"],
        ["artwork", "Do you already have a logo or artwork?"],
        ["size", "Approximate size? Small, medium, large, or not sure?"],
        ["locationType", "Will the sign be indoor or outdoor?"],
        ["installation", "Do you need installation?"],
        ["projectType", "New business, replacing an existing sign, or updating branding?"],
        ["projectAddress", "Project address"],
        ["timeline", "When do you need it completed?"],
        ["photos", "Can you provide a photo of where the sign will be installed?"],
        ["notes", "Anything else we should know?"]
      ]);
    },

    metalSigns: function () {
      this.customLeadForm("Metal Signs", [
        ["metalSignType", "What type of metal sign? Street, parking, no parking, reserved, directional, business, building, property, safety, warning, or custom?"],
        ["size", "Do you know the size? 12x18, 18x24, 24x36, custom, or not sure?"],
        ["quantity", "How many do you need?"],
        ["mounting", "How will it be mounted? Post, wall, fence, building, or need help deciding?"],
        ["holes", "Do you need pre-drilled holes?"],
        ["artwork", "Do you already have artwork or wording?"],
        ["timeline", "When do you need it?"],
        ["notes", "Any extra details?"]
      ]);
    },

    decalsWraps: function () {
      this.customLeadForm("Decals / Stickers / Wraps", [
        ["projectType", "What do you need? Decals, stickers, window graphics, wall graphics, vehicle lettering, partial wrap, full wrap, or not sure?"],
        ["vehicleOrSurface", "What is this going on? Vehicle, window, wall, door, floor, equipment, product packaging, or other?"],
        ["size", "Do you know the size?"],
        ["quantity", "How many do you need?"],
        ["indoorOutdoor", "Indoor or outdoor use?"],
        ["installation", "Do you need installation?"],
        ["artwork", "Do you already have artwork or design files?"],
        ["photos", "Can you provide photos of the vehicle, window, wall, or surface?"],
        ["timeline", "When do you need it completed?"],
        ["notes", "Anything else we should know?"]
      ]);
    },

    customLeadForm: function (product, fields) {
      let html = `<div class="aifd-msg">I’ll collect the details so the Express Signs team can review your project and follow up with a custom estimate.</div>`;
      fields.forEach(f => {
        html += `<input id="${f[0]}" placeholder="${f[1]}">`;
      });
      html += `
        <input id="leadName" placeholder="Your name">
        <input id="leadPhone" placeholder="Phone number">
        <input id="leadEmail" placeholder="Email">
        <button onclick="AIFrontDesk.submitCustomLead('${product}', '${fields.map(f => f[0]).join(",")}')">Send Request</button>
        <button onclick="AIFrontDesk.home()" class="aifd-secondary">Back</button>
      `;
      body(html);
    },

    submitCustomLead: function (product, fieldList) {
      const ids = fieldList.split(",");
      let details = "";
      ids.forEach(id => {
        const el = document.getElementById(id);
        details += id + ": " + (el ? el.value : "") + "\\n";
      });
      this.currentLead = {
        product,
        price: "Custom Estimate",
        details
      };
      this.submitLeadFromContactFields();
    },

    leadForm: function (product, price, details) {
      this.currentLead = { product, price, details };
      body(`
        <div class="aifd-msg">
          Estimated total: <strong>${price}</strong><br><br>
          I can send this request to our team to confirm details, artwork, timeline, and next steps.
          <br><br>${K.businessInfo.artwork}
        </div>
        <input id="leadName" placeholder="Your name">
        <input id="leadPhone" placeholder="Phone number">
        <input id="leadEmail" placeholder="Email">
        <textarea id="leadNotes" placeholder="Anything else we should know? Artwork ready? Timeline?"></textarea>
        <button onclick="AIFrontDesk.submitLead()">Send My Request</button>
        <button onclick="AIFrontDesk.orderMenu()" class="aifd-secondary">Back</button>
      `);
    },

    submitLead: function () {
      const lead = this.currentLead || {};
      const name = document.getElementById("leadName").value;
      const phone = document.getElementById("leadPhone").value;
      const email = document.getElementById("leadEmail").value;
      const notes = document.getElementById("leadNotes").value;

      const subject = encodeURIComponent("New " + lead.product + " Request from AI Front Desk");
      const msg =
        "Product: " + lead.product + "\\n" +
        "Estimated Price: " + lead.price + "\\n" +
        "Details: " + lead.details + "\\n\\n" +
        "Name: " + name + "\\n" +
        "Phone: " + phone + "\\n" +
        "Email: " + email + "\\n" +
        "Notes: " + notes;

      window.location.href = "mailto:" + K.emailTo + "?subject=" + subject + "&body=" + encodeURIComponent(msg);
    },

    submitLeadFromContactFields: function () {
      const lead = this.currentLead || {};
      const name = document.getElementById("leadName").value;
      const phone = document.getElementById("leadPhone").value;
      const email = document.getElementById("leadEmail").value;

      const subject = encodeURIComponent("New " + lead.product + " Request from AI Front Desk");
      const msg =
        "Product: " + lead.product + "\\n" +
        "Estimated Price: " + lead.price + "\\n\\n" +
        "Details:\\n" + lead.details + "\\n" +
        "Name: " + name + "\\n" +
        "Phone: " + phone + "\\n" +
        "Email: " + email;

      window.location.href = "mailto:" + K.emailTo + "?subject=" + subject + "&body=" + encodeURIComponent(msg);
    },

    quote: function () {
      body(`
        <div class="aifd-msg">I can help collect the details for a quote.</div>
        <input id="qProduct" placeholder="Product needed">
        <input id="qQty" placeholder="Quantity">
        <input id="qTimeline" placeholder="Timeline / when do you need it?">
        <input id="qBudget" placeholder="Budget, if known">
        <input id="qName" placeholder="Your name">
        <input id="qPhone" placeholder="Phone">
        <input id="qEmail" placeholder="Email">
        <textarea id="qNotes" placeholder="Size, installation address, artwork, photos, or other details"></textarea>
        <button onclick="AIFrontDesk.submitQuote()">Send Quote Request</button>
        <button onclick="AIFrontDesk.home()" class="aifd-secondary">Back</button>
      `);
    },

    submitQuote: function () {
      const msg =
        "Product: " + document.getElementById("qProduct").value + "\\n" +
        "Quantity: " + document.getElementById("qQty").value + "\\n" +
        "Timeline: " + document.getElementById("qTimeline").value + "\\n" +
        "Budget: " + document.getElementById("qBudget").value + "\\n\\n" +
        "Name: " + document.getElementById("qName").value + "\\n" +
        "Phone: " + document.getElementById("qPhone").value + "\\n" +
        "Email: " + document.getElementById("qEmail").value + "\\n" +
        "Notes: " + document.getElementById("qNotes").value;

      window.location.href =
        "mailto:" + K.emailTo +
        "?subject=" + encodeURIComponent("New Quote Request from AI Front Desk") +
        "&body=" + encodeURIComponent(msg);
    }
  };

 document.addEventListener("DOMContentLoaded", function () {
  css();
  build();
  window.AIFrontDesk.home();

  document.addEventListener("click", function (e) {
    const btn = e.target.closest("[data-product]");
    if (!btn) return;

    e.preventDefault();
    e.stopPropagation();

    const product = btn.dataset.product;

    window.AIFrontDesk.open();

    setTimeout(function () {
      const routes = {
        "yard-signs": "yardSigns",
        "banners": "banners",
        "feather-flags": "featherFlags",
        "business-cards": "businessCards",
        "a-frame-signs": "aFrames",
        "fatheads": "fatheads",
        "real-estate-signs": "realEstateSigns",
        "contractor-signs": "contractorSigns",
        "political-signs": "politicalSigns",
        "metal-signs": "metalSigns",
        "decals-wraps": "decalsWraps",
        "general-sign-order": "orderMenu"
      };

      const method = routes[product];

      if (method && typeof window.AIFrontDesk[method] === "function") {
        window.AIFrontDesk[method]();
      } else {
        window.AIFrontDesk.orderMenu();
      }
    }, 100);
  });
});
})();